import Account from '@/api/accounts'

export default {
  namespaced: true,
  state: {
    email: '',
    captcha: '',
    error: null,
    loading: false
  },
  getters: {
    formData: state => {
      return {
        email: state.email,
        captcha: state.captcha
      }
    }
  },
  mutations: {
    setEmail (state, email) {
      state.email = email
    },
    setCaptcha (state, captcha) {
      state.captcha = captcha
    },
    setAccountName (state, accountName) {
      state.accountName = accountName
    },
    setAuthority (state, authority) {
      state.authority = authority
    },
    setPublicKey (state, publicKey) {
      state.publicKey = publicKey
    },
    setError (state, error) {
      state.error = error
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    resetData (state) {
      state.email = ''
      state.captcha = ''
      state.loading = false
      state.error = null
    }
  },
  actions: {
    async getCredentialsFor ({ dispatch, rootState, rootGetters }, account) {
      await dispatch('scatter/forgetIdentity', {}, { root: true })
      await dispatch('scatter/getCredentials', {}, { root: true })
      const accounts = rootGetters['scatter/accounts']
      const correct = accounts.find((acc) => acc.name === account)
      if (!correct) {
        throw new Error(`Incorrect EOS account for email, please try again 
                        and select the correct account in Scatter`)
      }
    },
    async login ({ commit, getters }) {
      commit('setLoading', true)
      const data = getters.formData
      try {
        await Account.login(data)
      } catch (error) {
        commit('setError', error)
        commit('setLoading', false)
        throw error
      }
      commit('setLoading', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login-form.js